import { environment } from "src/environments/environment";

const CURRENT_YEAR = new Date().getFullYear();
export const LEGACY_URL = `${window.caUrl}/app`;

export const MARKETDATA_COPYRIGHT_MESSAGE = `Pricing and market data ${String.fromCharCode(
  169,
)} ${CURRENT_YEAR} ICE. All rights reserved.`;

export const MARKET_DATA_LIST = [
  {
    id: 10,
    label: "Last Closing Price",
    checked: false,
  },
  {
    id: 11,
    label: "Market Cap",
    checked: false,
  },
  {
    id: 34,
    label: "Enterprise Value",
    checked: false,
  },
];

export const MONTH_DATE_ABB_YEAR_FORMAT = "MMM Do YYYY";

export const REVISION_ESTIMATES_SUBCOLUMNS = [
  {
    label: "Next Interim",
    id: "next_interim_surprise",
    hasSort: true,
  },
  {
    label: "FY1",
    id: "Y1_surprise",
    hasSort: true,
  },
  {
    label: "FY2",
    id: "Y2_surprise",
    hasSort: true,
  },
  {
    label: "FY3",
    id: "Y3_surprise",
    hasSort: true,
  },
];

export const REVISION_ANALYSIS_DATA_KEYS = [
  {
    label: "FY End",
    id: "relative_period_Y1",
    hasSort: true,
  },
  {
    label: "Last Reported Interim",
    id: "last_reported_interim",
    hasSort: false,
  },
  {
    label: "Date of Last Earnings Release",
    id: "last_earnings_date",
    hasSort: true,
  },
  {
    label: "Earnings Surprise (Last Reported Interim)",
    id: "earnings_surprise",
    isLineItemColumn: true,
    hasSort: false,
    subColumns: [
      {
        label: "Consensus (day before earnings)",
        id: "last_reported_interim_preq",
        hasSort: true,
      },
      {
        label: "VA Actuals",
        id: "last_reported_interim_current",
        hasSort: true,
      },
      {
        label: "Surprise (%)",
        id: "last_reported_interim_surprise",
        hasSort: true,
      },
    ],
  },
  {
    label: "Estimates (Current vs. Day before Last Earnings Release)",
    id: "estimates",
    isLineItemColumn: true,
    hasSort: false,
    subColumns: REVISION_ESTIMATES_SUBCOLUMNS,
  },
  {
    label: "3 Yr Forward CAGR (Before)",
    id: "3yr_fwd_cagr_before",
    isLineItemColumn: true,
    hasSort: true,
  },
  {
    label: "3 Yr Forward CAGR (After)",
    id: "3yr_fwd_cagr_after",
    isLineItemColumn: true,
    hasSort: true,
  },
];

export const ANALYSIS_RED = "#F8696B";
export const ANALYSIS_BLUE = "#3EAE63";

export const HISTORICAL_SURPRISE_SUBCOLUMNS = [
  {
    label: "Prior Quarter",
    id: "Q-1_surprise",
    hasSort: true,
  },
  {
    label: "2 Quarters / 1 half ago",
    id: "Q-2_surprise",
    hasSort: true,
  },
  {
    label: "3 Quarters ago",
    id: "Q-3_surprise",
    hasSort: true,
  },
  {
    label: "4 Quarters ago / 2 half ago",
    id: "Q-4_surprise",
    hasSort: true,
  },
  {
    label: "Average Surprise",
    id: "quarter_average_surprise",
    hasSort: true,
  },
];

export const SURPRISE_ANALYSIS_DATA_KEYS = [
  {
    label: "FY End",
    id: "relative_period_Y1",
    hasSort: true,
  },
  {
    label: "Next Interim",
    id: "next_interim",
    hasSort: false,
  },
  {
    label: "Next Earnings Date",
    id: "next_earnings_date",
    hasSort: true,
  },
  {
    label: "Earnings Preview",
    id: "earnings_preview",
    isLineItemColumn: true,
    hasSort: false,
    subColumns: [
      {
        label: "Upcoming Interim",
        id: "upcoming_interim",
        hasSort: true,
      },
      {
        label: "YoY",
        id: "upcoming_interim_yoy",
        hasSort: true,
      },
      {
        label: "Sequential Growth",
        id: "upcoming_interim_seq",
        hasSort: true,
      },
    ],
  },
  {
    label: "Historical Surprise",
    id: "historical_surprise",
    isLineItemColumn: true,
    hasSort: false,
    subColumns: HISTORICAL_SURPRISE_SUBCOLUMNS,
  },
];

export const PAGE_NAME = {
  industryRevision: "revisionanalysis",
  industrySurprise: "surpriseanalysis",
};

export const PERIOD_DISPLAY_PREFIXES = {
  cal: {
    abs: {
      year: "CY-",
      quarter: "QCY-",
      halfYear: "HCY-",
    },
    rel: {
      year: "C",
      quarter: "CQ",
      halfYear: "CH",
    },
  },
  fy: {
    abs: {
      year: "FY-",
      quarter: "QFY-",
      halfYear: "HFY-",
    },
    rel: {
      year: "F",
      quarter: "FQ",
      halfYear: "FH",
    },
  },
};

export const GROWTH_OPTIONS = [
  { label: "Values", value: "values", checked: true },
  { label: "YoY%", value: "yoy", checked: false },
];

export const REVISION_OPTIONS = [
  { label: "1 month", value: "1m" },
  { label: "3 months", value: "3m" },
  { label: "12 months", value: "12m" },
  { label: "Custom", value: "custom" },
];

// export const SUPPORT_LINKS = {
//   base_link: environment.supportLink,
//   en_US: "/s/article",
//   articles: {
//     reaffirmed_in_consensus: "/reaffirmed-transactions-in-current-consensus",
//     calendarization_methods: "/calendarization-methods",
//     rolling_periods_calculation_methods: "/ltm-ntm-and-stm-calculation-methods",
//     target_price_rating_concensus_calc:
//       "/getting-started-with-insights-target-price-and-ratings-for-the-sell-side",
//     target_price_rating_normalization:
//       "/getting-started-with-insights-target-price-and-ratings-for-the-sell-side",
//     sli_methodology: "/primary-standardized-line-item-sli-methodology",
//   },
// };

const WINDOW_APIURL = environment?.apiUrl || window.apiUrl;
export const HIGHCHARTS_EXPORT_URL = `${WINDOW_APIURL}/highcharts-export`;
